(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facts-legal-claims"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const superscriptDigits = {
      '⁰': '0',
      '¹': '1',
      '²': '2',
      '³': '3',
      '⁴': '4',
      '⁵': '5',
      '⁶': '6',
      '⁷': '7',
      '⁸': '8',
      '⁹': '9'
    };

    const enhance = (ledger) => {
      if (!ledger || ledger.dataset.enhanced === 'true') return;
      ledger.dataset.enhanced = 'true';

      const main = ledger.closest('main') || document.querySelector('main');
      if (!main) return;

      const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent || !/[⁰¹²³⁴⁵⁶⁷⁸⁹]/.test(node.nodeValue || '')) return NodeFilter.FILTER_REJECT;
          if (ledger.contains(parent) || parent.closest('a, sup, script, style, textarea, select')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach((node) => {
        const text = node.nodeValue || '';
        const matches = [...text.matchAll(/[⁰¹²³⁴⁵⁶⁷⁸⁹]+/g)];
        if (!matches.length) return;

        const fragment = document.createDocumentFragment();
        let cursor = 0;

        matches.forEach((match) => {
          const number = Number([...match[0]].map((digit) => superscriptDigits[digit]).join(''));
          const target = ledger.querySelector(`[data-claim-number="${number}"]`);
          fragment.append(document.createTextNode(text.slice(cursor, match.index)));

          if (target) {
            const marker = document.createElement('span');
            const superscript = document.createElement('sup');
            marker.className = 'facts-claim-ref';
            superscript.textContent = String(number);
            marker.append(superscript);
            fragment.append(marker);
          } else {
            fragment.append(document.createTextNode(match[0]));
          }

          cursor = match.index + match[0].length;
        });

        fragment.append(document.createTextNode(text.slice(cursor)));
        node.replaceWith(fragment);
      });


    };

    const enhanceAll = (root = document) => root.querySelectorAll('[data-legal-ledger]').forEach(enhance);
    enhanceAll();
    document.addEventListener('shopify:section:load', (event) => enhanceAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
